import { gql } from 'graphql-request';
import { baseApi } from './baseApi';

export const gradeLevelApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // queries
    getGradeLevels: builder.query({
      query: () => ({
        body: gql`
          query FindGradeLevels {
            findGradeLevels {
              id
              code
              name
              created_at
              updated_at
            }
          }
        `,
      }),
      transformResponse: (res: any) => res.findGradeLevels,
    }),
  }),
  overrideExisting: false,
});

export const { useGetGradeLevelsQuery, useLazyGetGradeLevelsQuery } = gradeLevelApi;
